import React from "react";

const MhsNilai = () => {
  return <div>Sedang dalam pembuatan</div>;
};

export default MhsNilai;
